<template>
  <svg
    width="51"
    height="51"
    viewBox="0 0 54 54"
    stroke="currentColor"
    :class="customStyle"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.5002 0.0833359C39.5378 0.0833359 50.9168 11.4624 50.9168 25.5C50.9168 39.5376 39.5378 50.9167 25.5002 50.9167C11.4625 50.9167 0.0834961 39.5376 0.0834961 25.5H5.16683C5.16683 36.7291 14.2711 45.8333 25.5002 45.8333C36.7292 45.8333 45.8335 36.7291 45.8335 25.5C45.8335 14.2709 36.7292 5.16667 25.5002 5.16667C19.2375 5.16667 13.6357 7.99808 9.90704 12.4485L15.3335 17.875H0.0834961V2.625L6.30295 8.84192C10.9618 3.479 17.8345 0.0833359 25.5002 0.0833359ZM28.0418 12.7917V24.4452L36.2845 32.6878L32.688 36.2843L22.9585 26.5497V12.7917H28.0418Z"
      fill="#FD8D25"
    />
  </svg>
</template>

<script>
export default {
  name: 'ProgressIcon',
  props: {
    customStyle: {
      type: String,
      default: 'h-5 w-5',
    },
  },
}
</script>
